var url="";
var short_url="";
switch(window.location.hostname){
  case "localhost":
    // short_url = "http://inpb.sitilab.net/";
    // url = "http://inpb.sitilab.net/api/";
    short_url = "http://localhost:60341/";
    url = "http://localhost:60341/api/";
    break;
  case "hap":
    short_url="https://hapb/";
    url = "https://hapb/api/";
    break;
  case "dsbb":
    short_url="https://dsbbb/";
    url = "https://dsbbb/api/";
    break;
  case "michoacan.sitilab.net":
    short_url = "https://michoacanb.sitilab.net/";
    url = "https://michoacanb.sitilab.net/api/";
    break;
  case "pachuca.sitilab.net":
    short_url = "https://pachucab.sitilab.net/";
    url = "https://pachucab.sitilab.net/api/";
    break;
  case "fresnillo.sitilab.net":
    short_url = "https://fresnillob.sitilab.net/";
    url = "https://fresnillob.sitilab.net/api/";
    break;
  case "zacatecas.sitilab.net":
    short_url = "https://zacatecasb.sitilab.net/";
    url = "https://zacatecasb.sitilab.net/api/";
    break;
  case "ags.sitilab.net":
    short_url = "https://agsb.sitilab.net/";
    url = "https://agsb.sitilab.net/api/";
    break;
  case "imss.sitilab.net":
    short_url = "https://imssb.sitilab.net/";
    url = "https://imssb.sitilab.net/api/";
    break;
  case "hermosillo.sitilab.net":
    short_url = "https://hermosillob.sitilab.net/";
    url = "https://hermosillob.sitilab.net/api/";
    break;
  case "obregon.sitilab.net":
    short_url = "https://obregonb.sitilab.net/";
    url = "https://obregonb.sitilab.net/api/";
    break;
  case "qro.sitilab.net":
    short_url = "https://qrob.sitilab.net/";
    url = "https://qrob.sitilab.net/api/";
    break;
  case "tabasco.sitilab.net":
    short_url = "https://tabascob.sitilab.net/";
    url = "https://tabascob.sitilab.net/api/";
    break;
  case "shematologicos.idbb.com.mx":
    short_url = "https://www.shematologicos.idbb.com.mx/";
    url = "https://www.shematologicos.idbb.com.mx/api/";
    break;
  case "imedmex2.sitilab.net":
    short_url = "https://imedmex.southcentralus.cloudapp.azure.com/";
    url = "https://imedmex.southcentralus.cloudapp.azure.com/Api/";
    break;
  case "fresnillo.dsbb.com.mx":
    short_url = "https://www.fresnillo.dsbb.com.mx/";
    url = "https://www.fresnillo.dsbb.com.mx/Api/";
    break;
  case "zacatecas.dsbb.com.mx":
    short_url = "https://www.zacatecas.dsbb.com.mx/";
    url = "https://www.zacatecas.dsbb.com.mx/Api/";
    break;
  case "hgm.sitilab.net":
    short_url = "https://hgmb.sitilab.net/";
    url = "https://hgmb.sitilab.net/Api/";
    break;
  case "imu.sitilab.net":
    short_url = "https://imb.sitilab.net/";
    url = "https://imb.sitilab.net/api/";
    break;
  case "morelos.sitilab.net":
    short_url = "https://morelosb.sitilab.net/";
    url = "https://morelosb.sitilab.net/api/";
    break;
  case "morelos.dsbb.com.mx":
    short_url = "https://www.morelos.dsbb.com.mx/";
    url = "https://www.morelos.dsbb.com.mx/api/";
    break
  case "inp.sitilab.net":
    short_url = "https://inpb.sitilab.net/";
    url = "https://inpb.sitilab.net/api/";
    break;
  case "ssu.sitilab.net":
    short_url = "https://ssb.sitilab.net/";
    url = "https://ssb.sitilab.net/api/";
    break;
  case "imss.sitilab.net":
    short_url = "https://imssb.sitilab.net/";
    url = "https://imssb.sitilab.net/api/";
    break;
  case "robirosa.sitilab.net":
    short_url = "https://robirosab.sitilab.net/";
    url = "https://robirosab.sitilab.net/Api/";
    break;
  case "ventas":
    short_url = "https://ventas:444/";
    url = "https://ventas:444/api/";
    break;
  case "www.merida.dsbb.com.mx":
    short_url = "https://merida.dsbb.com.mx/";
    url = "https://merida.dsbb.com.mx/api/";
    break;
  case "inp.dsbb.com.mx":
    short_url = "https://www.inp.dsbb.com.mx/";
    url = "https://www.inp.dsbb.com.mx/api/";
    break;
  case "michoacan.dsbb.com.mx":
    short_url = "https://www.michoacan.dsbb.com.mx/";
    url = "https://www.michoacan.dsbb.com.mx/api/";
    break;
  case "sedena.sitilab.net":
    short_url = "https://sedenab.sitilab.net/";
    url = "https://sedenab.sitilab.net/api/";
    break;
  case "merida.sitilab.net":
    short_url = "https://meridab.sitilab.net/";
    url = "https://meridab.sitilab.net/api/";
    break;
  case "inteldiagnostics.sitilab.net":
    short_url = "https://inteldiagnosticsb.sitilab.net/";
    url = "https://inteldiagnosticsb.sitilab.net/api/";
    break;
  case "sedena-hm.sitilab.net":
    short_url = "https://sedena-hmb.sitilab.net/";
    url = "https://sedena-hmb.sitilab.net/api/";
    break;
  case "sedena-mty.sitilab.net":
    short_url = "https://sedena-mtyb.sitilab.net/";
    url = "https://sedena-mtyb.sitilab.net/api/";
    break;
  case "infantil.sitilab.net":
    short_url = "https://infantilb.sitilab.net/";
    url = "https://infantilb.sitilab.net/api/";
    break;
  case "espanol.sitilab.net":
    short_url = "https://espanolb.sitilab.net/";
    url = "https://espanolb.sitilab.net/api/";
    break;
  case "dsbb.sitilab.net":
    short_url = "https://dsbbb.sitilab.net/";
    url = "https://dsbbb.sitilab.net/api/";
    break;
  case "aguascalientes.dsbb.com.mx":
    short_url = "https://www.aguascalientes.dsbb.com.mx/";
    url = "https://www.aguascalientes.dsbb.com.mx/api/";
    break;
  case "licona.idbb.com.mx":
    short_url = "https://www.licona.idbb.com.mx/";
    url = "https://www.licona.idbb.com.mx/api/";
    break;
  case "shematologicosalta.idbb.com.mx":
    short_url = "https://www.shematologicosalta.idbb.com.mx/";
    url = "https://www.shematologicosalta.idbb.com.mx/api/";
    break;
  case "ixtapaluca.sitilab.net":
    short_url = "https://ixtapalucab.sitilab.net/";
    url = "https://ixtapalucab.sitilab.net/api/";
    break;
  case "smedicachihuahua.dsbb.com.mx":
    short_url = "https://www.smedicachihuahua.dsbb.com.mx/";
    url = "https://www.smedicachihuahua.dsbb.com.mx/api/";
    break;
  case "bancosangresantiagoqro.dsbb.com.mx":
    short_url = "https://www.bancosangresantiagoqro.dsbb.com.mx/";
    url = "https://www.bancosangresantiagoqro.dsbb.com.mx/api/";
    break;
  case "bancosangresantiagosjr.dsbb.com.mx":
    short_url = "https://www.bancosangresantiagosjr.dsbb.com.mx/";
    url = "https://www.bancosangresantiagosjr.dsbb.com.mx/api/";
    break;
  case "cetsnayarit.dsbb.com.mx":
    short_url = "https://www.cetsnayarit.dsbb.com.mx/";
    url = "https://www.cetsnayarit.dsbb.com.mx/api/";
    break;
  case "nayarit.sitilab.net":
    short_url = "https://nayaritb.sitilab.net/";
    url = "https://nayaritb.sitilab.net/api/";
    break;
  case "issetbs.idbb.com.mx":
    short_url = "https://www.issetbs.idbb.com.mx/";
    url = "https://www.issetbs.idbb.com.mx/api/";
    break;
  case "issste-merida.sitilab.net":
    short_url = "https://issste-meridab.sitilab.net/";
    url = "https://issste-meridab.sitilab.net/api/";
    break;
  case "bshospitalsanjoseobregon.idbb.com.mx":
    short_url = "https://www.bshospitalsanjoseobregon.idbb.com.mx/";
    url = "https://www.bshospitalsanjoseobregon.idbb.com.mx/api/";
    break;
  case "cetscampeche.dsbb.com.mx":
    short_url = "https://www.cetscampeche.dsbb.com.mx/";
    url = "https://www.cetscampeche.dsbb.com.mx/api/";
    break;
  case "informaticamedica.dsbb.com.mx":
    short_url = "https://www.informaticamedica.dsbb.com.mx/";
    url = "https://www.informaticamedica.dsbb.com.mx/api/";
    break;
  case "celabs.dsbb.com.mx":
    short_url = "https://www.celabs.dsbb.com.mx/";
    url = "https://www.celabs.dsbb.com.mx/api/";
    break;
  default:
    //short_url = "http://192.168.15.173/";
    //url = "http://192.168.15.173/api/";
    //short_url =  "http://192.168.15.162/";
    //url = "http://192.168.15.162/api/";
    short_url = "http://localhost:50341/";
    url = "http://localhost:50341/api/";
}
export default {
  s3: {
    REGION: "YOUR_S3_UPLOADS_BUCKET_REGION",
    BUCKET: "YOUR_S3_UPLOADS_BUCKET_NAME"
  },
  apiGateway: {
    REGION: "YOUR_API_GATEWAY_REGION",
    short_url:short_url,
    URL: url,
  },
  cognito: {
    REGION: "YOUR_COGNITO_REGION",
    USER_POOL_ID: "YOUR_COGNITO_USER_POOL_ID",
    APP_CLIENT_ID: "YOUR_COGNITO_APP_CLIENT_ID",
    IDENTITY_POOL_ID: "YOUR_IDENTITY_POOL_ID"
  }
};